module.exports = __webpack_public_path__ + "img/opp-mechload.47088759.png";